import * as React from 'react';
import { useState, useEffect, useCallback, useMemo } from "react";
import { styled } from '@mui/material/styles';




import Collapse from '@mui/material/Collapse';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import {
    Card, CardHeader, CardMedia, CardContent, CardActions,
    Typography, IconButton, Avatar, Chip, Tooltip
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import ImageCarousel from './ImageCarousel';

// import React, { useState, useEffect, } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
    variants: [
        {
            props: ({ expand }) => !expand,
            style: {
                transform: 'rotate(0deg)',
            },
        },
        {
            props: ({ expand }) => !!expand,
            style: {
                transform: 'rotate(180deg)',
            },
        },
    ],
}));

export default function Cards({ packages, branches, onEdit }) {
    // track which slot is actually selected by ID
    const [selectedSlotId, setSelectedSlotId] = useState(null);

    const packageActiveStatus = (currentStatus, selectedPackage) => {
        console.log("Status changed:", currentStatus);
    };

    const currentBranch = useMemo(() => {
        return branches.find(b => b.ROWID === packages.branch_id);
    }, [branches, packages.branch_id]);

    return (
        <div className="w-full flex justify-center p-4">
            <Card
                sx={{
                    maxWidth: 340,
                    borderRadius: '16px',
                    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.2s ease-in-out',
                    '&:hover': { transform: 'translateY(-4px)' }
                }}
                className="flex flex-col bg-white border border-slate-100"
            >
                <CardHeader
                    avatar={
                        <Avatar
                            src={`https://ui-avatars.com/api/?name=${packages['name']}&background=72398E&color=fff`}
                            sx={{ width: 45, height: 45, borderRadius: '12px' }}
                        />
                    }
                    action={
                        <IconButton aria-label="settings">
                            <MoreVertIcon />
                        </IconButton>
                    }
                    title={<Typography variant="subtitle1" className="font-bold text-slate-800">{packages['name']}</Typography>}
                    subheader={<Chip label={packages['code']} size="small" sx={{ fontSize: '10px', height: '20px', mt: 0.5 }} />}
                />

                <div className="relative group">
                    <CardMedia sx={{ height: 220, position: "relative" }}>
                        <Swiper
                            modules={[Pagination, Navigation]}
                            slidesPerView={1}
                            navigation
                            pagination={{ clickable: true, dynamicBullets: true }}
                            className="h-full rounded-md mx-3"
                        >
                            {packages.images.map((img, index) => (
                                <SwiperSlide key={img.ROWID || index}>
                                    <img
                                        src={img.url}
                                        alt={`package-${index}`}
                                        className="w-full h-full object-cover rounded-xl"
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </CardMedia>
                    <div className="absolute top-4 right-6 z-10">
                        <div className="bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full shadow-sm border border-white/20">
                            <Typography variant="subtitle2" className="font-bold text-[#72398E]">
                                ₹{packages?.price}
                            </Typography>
                        </div>
                    </div>
                </div>

                <CardContent className="flex flex-col gap-3 pt-4">
                    {/* Branch Info */}
                    <div className="flex items-center text-slate-500 gap-1">
                        <LocationOnIcon sx={{ fontSize: 16 }} />
                        <Typography variant="caption" className="font-medium tracking-wide uppercase">
                            {currentBranch?.name || "Main Branch"}
                        </Typography>
                    </div>

                    {/* Time Slots Section */}
                    <div>
                        <div className="flex items-center gap-1 mb-2 text-slate-700">
                            <AccessTimeIcon sx={{ fontSize: 16 }} />
                            <Typography variant="body2" className="font-semibold">Available Slots</Typography>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {packages.time_slots.map((slot) => (
                                <button
                                    key={slot.time_slot_id}
                                    disabled={!slot.is_active}
                                    onClick={() => setSelectedSlotId(slot.time_slot_id)}
                                    className={`
                                        flex flex-col items-center px-3 py-1.5 rounded-lg text-[11px] font-medium border transition-all
                                        ${!slot.is_active
                                            ? "bg-slate-50 text-slate-300 border-slate-100 cursor-not-allowed"
                                            : selectedSlotId === slot.time_slot_id
                                                ? "bg-[#72398E] text-white border-[#72398E] shadow-md"
                                                : "bg-white text-slate-600 border-slate-200 hover:border-[#72398E] hover:text-[#72398E]"
                                        }
                                    `}
                                >
                                    <span>{slot.start_time}</span>
                                    <span className="opacity-70 text-[9px]">to {slot.end_time}</span>
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Description */}
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            fontSize: '0.825rem',
                            lineHeight: 1.5
                        }}
                    >
                        {packages?.description}
                    </Typography>
                </CardContent>

                <CardActions className="mt-auto px-4 pb-4 flex justify-between items-center border-t border-slate-50 pt-3">
                    <div className="flex items-center gap-2">
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                checked={!!packages?.is_active}
                                className="sr-only peer"
                                onChange={(e) => packageActiveStatus(e.target.checked, packages)}
                            />
                            <div className="w-10 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-500"></div>
                        </label>
                        <Typography variant="caption" className="font-bold text-slate-400">
                            {packages?.is_active ? "ACTIVE" : "INACTIVE"}
                        </Typography>
                    </div>

                    <Tooltip title="Edit Package">
                        <IconButton
                            onClick={onEdit}
                            sx={{
                                backgroundColor: '#f3e8ff',
                                '&:hover': { backgroundColor: '#72398E', color: 'white' },
                                color: '#72398E',
                                transition: '0.2s'
                            }}
                            size="small"
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </CardActions>
            </Card>
        </div>
    );
}